import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TermsAndConditionCms } from '../../interfaces/terms-and-condition-cms.interface';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';

@Component({
  selector: 'lmw-base-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html'
})
export class TermsAndConditionsComponent implements OnInit {

  public termsAndConditionsCmsData: TermsAndConditionCms;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.termsAndConditionsCmsData = this.route.snapshot.data.cmsData;
  }
}
